import axios from '@/axios';
import { useBookingStore } from '@/stores/booking';
import type { Pricing } from '@/types';
import type { AxiosResponse } from 'axios';
import { storeToRefs } from 'pinia';

type PricingApiResponse = AxiosResponse<Pricing>;

type PricingAPIPayload = {
  service_ids: number[];
  timeslot: string;
  date: string;
  discount_code?: string;
  giftcard_code?: string;
  giftcard_redeem_amount?: number;
  session_secret?: string;
  email?: string;
};

type GetPriceOptions = {
  email?: string;
};

export const usePrincing = () => {
  const getPrice = (options: GetPriceOptions) => {
    const {
      locationId,
      date,
      time,
      serviceIds,
      discountCode,
      giftcardCode,
      giftcardRedeemedAmount
    } = useBookingStore();
    const { pricing, paymentMethod } = storeToRefs(useBookingStore());
    const bookingData: PricingAPIPayload = {
      service_ids: serviceIds,
      timeslot: time,
      date: date,
      email: options.email || '',
      discount_code: discountCode?.code,
      session_secret: pricing.value?.quote?.discount?.session_secret,
      giftcard_code: giftcardCode?.code.replaceAll(' ', ''),
      giftcard_redeem_amount: giftcardRedeemedAmount || 0
    };

    return axios
      .post(`/locations/${locationId}/prices`, bookingData)
      .then(({ data }: PricingApiResponse) => {
        if (
          data.quote.payment_strategy === 'required' ||
          data.quote.payment_strategy === 'percentage'
        ) {
          paymentMethod.value = 'pay_online';
        }

        if (data.quote.payment_strategy === 'disabled') {
          data.quote.transaction_fee = 0;
          paymentMethod.value = 'pay_at_location';
        }

        pricing.value = data;
      });
  };

  return {
    getPrice
  };
};
